import { footerColumns, navLinks } from "@/mocks/archiveEntries";

const Footer = () => {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr] lg:gap-12">
          <div>
            <a href="#top" className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50 text-xl">
                <i className="ri-archive-drawer-line" />
              </span>
              <span className="leading-tight">
                <span className="block font-heading text-lg font-bold tracking-wide text-background-50">
                  黑料看料
                </span>
                <span className="block text-[11px] tracking-[0.28em] text-background-300">
                  存档 · 留档
                </span>
              </span>
            </a>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-background-300">
              黑料看料首页提供历史存档与留档记录，重要内容备份齐全，支持按时间或人物检索过往存证与底稿。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3 py-1.5 text-xs text-background-200">
                <i className="ri-refresh-line text-accent-300" />
                持续更新
              </span>
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3 py-1.5 text-xs text-background-200">
                <i className="ri-fingerprint-line text-accent-300" />
                批次可追溯
              </span>
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">
                {column.title}
              </h3>
              <ul className="mt-5 flex flex-col gap-3">
                {column.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#archive"
                      className="text-sm text-background-300 transition-colors hover:text-accent-300"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap items-center gap-x-6 gap-y-3 border-t border-background-50/15 pt-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-sm text-background-300 transition-colors hover:text-accent-300"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-4 border-t border-background-50/15 pt-8 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 黑料看料 · 存档留档档案库。页面内容为档案留档展示，仅供参考与回看。</p>
          <p className="text-background-400">
            本页为单页展示 · 不含分类页与详情页
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;